import { defineTokens } from "@chakra-ui/react";

// This take a min and max px value and returns the 'middle' value
// in the clamp function. The middle value is a calculation based on viewport width
// https://css-tricks.com/linearly-scale-font-size-with-css-clamp-based-on-the-viewport/
const clampRamp = (minPx: number, maxPx: number) => {
  const slope = (maxPx - minPx) / (840 - 360);
  const yAxisIntersection = -360 * slope + minPx;
  return `-${(yAxisIntersection / 100).toFixed(4)}rem + ${(slope * 100).toFixed(
    4,
  )}vw`;
};

export const fontSizes = defineTokens.fontSizes({
  xxs: {
    value: "1rem",
  },
  xs: {
    value: `clamp(1.2rem, ${clampRamp(7, 14)}, 1.6rem)`,
  },
  sm: {
    value: `clamp(1.4rem, ${clampRamp(10, 20)}, 2rem)`,
  },
  md: {
    value: `clamp(1.4rem, ${clampRamp(14, 28)}, 2.8rem)`,
  },
  lg: {
    value: `clamp(2rem, ${clampRamp(20, 40)}, 4rem)`,
  },
  xl: {
    value: `clamp(2.8rem, ${clampRamp(28, 56)}, 5.6rem)`,
  },
  xxl: {
    value: `clamp(4rem, ${clampRamp(40, 80)}, 8rem)`,
  },
  jumbo: {
    value: `clamp(5.6rem, ${clampRamp(56, 112)}, 11.2rem)`,
  },
  "4xl": {
    value: "2.25rem",
  },
  "5xl": {
    value: "3rem",
  },
  "6xl": {
    value: "3.75rem",
  },
  "7xl": {
    value: "4.5rem",
  },
  "8xl": {
    value: "6rem",
  },
  "9xl": {
    value: "8rem",
  },
});
